import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IUserNameAvailability {
  username: string;
  existsOnServer?: boolean;
  existsOnSite?: boolean;
  displayName: string;
  userAuthSetting?: string; //value should match SiteUserAuthSetting values
}

export interface ICheckUserNamesParams {
  usernames: string[];
}

export interface ICheckUserNamesResult extends IResult {
  users: IUserNameAvailability[];
}

export class CheckUserNamesRequest extends Request<ICheckUserNamesParams, ICheckUserNamesResult> {
  constructor(params: ICheckUserNamesParams) {
    super('checkUserNames', params);
  }
}
